import { KeyLabel, MOD } from './KeyLabel';

export const KeyLabelCanadian_multilingual: KeyLabel[] = [
  {
    code: 4,
    label: 'A',
    meta: [
      {
        label: 'Æ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 5,
    label: 'B',
    meta: [
      {
        label: '”',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 6,
    label: 'C',
    meta: [
      {
        label: '¢',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 7,
    label: 'D',
    meta: [
      {
        label: 'Ð',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 8,
    label: 'E',
    meta: [
      {
        label: '€',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: 'Œ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 9,
    label: 'F',
  },
  {
    code: 10,
    label: 'G',
    meta: [
      {
        label: 'Ŋ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 11,
    label: 'H',
    meta: [
      {
        label: 'Ħ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 12,
    label: 'I',
    meta: [
      {
        label: '→',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 13,
    label: 'J',
    meta: [
      {
        label: 'Ĳ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 14,
    label: 'K',
    meta: [
      {
        label: 'ĸ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 15,
    label: 'L',
    meta: [
      {
        label: 'Ŀ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 16,
    label: 'M',
    meta: [
      {
        label: 'μ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 17,
    label: 'N',
    meta: [
      {
        label: 'ŉ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 18,
    label: 'O',
    meta: [
      {
        label: 'Ø',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 19,
    label: 'P',
    meta: [
      {
        label: 'Þ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 20,
    label: 'Q',
    meta: [
      {
        label: 'Ω',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 21,
    label: 'R',
    meta: [
      {
        label: '¶',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 22,
    label: 'S',
    meta: [
      {
        label: 'ß',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 23,
    label: 'T',
    meta: [
      {
        label: 'Ŧ',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 24,
    label: 'U',
    meta: [
      {
        label: '↓',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 25,
    label: 'V',
    meta: [
      {
        label: '“',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 26,
    label: 'W',
    meta: [
      {
        label: 'Ł',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 27,
    label: 'X',
    meta: [
      {
        label: '»',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 28,
    label: 'Y',
    meta: [
      {
        label: '←',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 29,
    label: 'Z',
    meta: [
      {
        label: '«',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 30,
    label: '1',
    meta: [
      {
        label: '!',
        modifiers: MOD.SFT,
      },
      {
        label: '!',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¹',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '¡',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '¡',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 31,
    label: '2',
    meta: [
      {
        label: '@',
        modifiers: MOD.SFT,
      },
      {
        label: '@',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '²',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 32,
    label: '3',
    meta: [
      {
        label: '#',
        modifiers: MOD.SFT,
      },
      {
        label: '#',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '³',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '£',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '£',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 33,
    label: '4',
    meta: [
      {
        label: '$',
        modifiers: MOD.SFT,
      },
      {
        label: '$',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¤',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¼',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 34,
    label: '5',
    meta: [
      {
        label: '%',
        modifiers: MOD.SFT,
      },
      {
        label: '%',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '½',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '⅜',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '⅜',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 35,
    label: '6',
    meta: [
      {
        label: '?',
        modifiers: MOD.SFT,
      },
      {
        label: '?',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¾',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '⅝',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '⅝',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 36,
    label: '7',
    meta: [
      {
        label: '&',
        modifiers: MOD.SFT,
      },
      {
        label: '&',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '{',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '⅞',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '⅞',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 37,
    label: '8',
    meta: [
      {
        label: '*',
        modifiers: MOD.SFT,
      },
      {
        label: '*',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '}',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '™',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '™',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 38,
    label: '9',
    meta: [
      {
        label: '(',
        modifiers: MOD.SFT,
      },
      {
        label: '(',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '[',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '±',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '±',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 39,
    label: '0',
    meta: [
      {
        label: ')',
        modifiers: MOD.SFT,
      },
      {
        label: ')',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: ']',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
    ],
  },
  {
    code: 45,
    label: '-',
    meta: [
      {
        label: '_',
        modifiers: MOD.SFT,
      },
      {
        label: '_',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¿',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '¿',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 46,
    label: '=',
    meta: [
      {
        label: '+',
        modifiers: MOD.SFT,
      },
      {
        label: '+',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '¬',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '¸ (dead)',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '˛ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 47,
    label: '^ (dead)',
    meta: [
      {
        label: '¨ (dead)',
        modifiers: MOD.SFT,
      },
      {
        label: '¨ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '` (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '° (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '° (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 48,
    label: 'Ç',
    meta: [
      {
        label: '~ (dead)',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '~',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
    ],
  },
  {
    code: 50,
    label: 'À',
  },
  {
    code: 51,
    label: ';',
    meta: [
      {
        label: ':',
        modifiers: MOD.SFT,
      },
      {
        label: ':',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '°',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '´ (dead)',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '˝ (dead)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 52,
    label: 'É',
  },
  {
    code: 53,
    label: '/',
    meta: [
      {
        label: '(backslash)',
        modifiers: MOD.SFT,
      },
      {
        label: '(backslash)',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '|',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '(soft hyphen)',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '(soft hyphen)',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 54,
    label: ',',
    meta: [
      {
        label: "'",
        modifiers: MOD.SFT,
      },
      {
        label: "'",
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '<',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '―',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '×',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '×',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 55,
    label: '.',
    meta: [
      {
        label: '"',
        modifiers: MOD.SFT,
      },
      {
        label: '"',
        modifiers: MOD.RIGHT | MOD.SFT,
      },
      {
        label: '>',
        modifiers: MOD.RIGHT | MOD.ALT,
      },
      {
        label: '˙ (dead)',
        modifiers: MOD.RIGHT | MOD.CTL,
      },
      {
        label: '÷',
        modifiers: MOD.SFT | MOD.RIGHT | MOD.CTL,
      },
      {
        label: '÷',
        modifiers: MOD.RIGHT | MOD.SFT | MOD.CTL,
      },
    ],
  },
  {
    code: 56,
    label: 'É',
  },
  {
    code: 100,
    label: 'Ù',
  },
  {
    code: 542,
    label: '!',
  },
  {
    code: 543,
    label: '@',
  },
  {
    code: 544,
    label: '#',
  },
  {
    code: 545,
    label: '$',
  },
  {
    code: 546,
    label: '%',
  },
  {
    code: 547,
    label: '?',
  },
  {
    code: 548,
    label: '&',
  },
  {
    code: 549,
    label: '*',
  },
  {
    code: 550,
    label: '(',
  },
  {
    code: 551,
    label: ')',
  },
  {
    code: 557,
    label: '_',
  },
  {
    code: 558,
    label: '+',
  },
  {
    code: 559,
    label: '¨ (dead)',
  },
  {
    code: 563,
    label: ':',
  },
  {
    code: 565,
    label: '(backslash)',
  },
  {
    code: 566,
    label: "'",
  },
  {
    code: 567,
    label: '"',
  },
  {
    code: 4356,
    label: 'Æ',
  },
  {
    code: 4357,
    label: '”',
  },
  {
    code: 4358,
    label: '¢',
  },
  {
    code: 4359,
    label: 'Ð',
  },
  {
    code: 4360,
    label: 'Œ',
  },
  {
    code: 4362,
    label: 'Ŋ',
  },
  {
    code: 4363,
    label: 'Ħ',
  },
  {
    code: 4364,
    label: '→',
  },
  {
    code: 4365,
    label: 'Ĳ',
  },
  {
    code: 4366,
    label: 'ĸ',
  },
  {
    code: 4367,
    label: 'Ŀ',
  },
  {
    code: 4368,
    label: 'μ',
  },
  {
    code: 4369,
    label: 'ŉ',
  },
  {
    code: 4370,
    label: 'Ø',
  },
  {
    code: 4371,
    label: 'Þ',
  },
  {
    code: 4372,
    label: 'Ω',
  },
  {
    code: 4373,
    label: '¶',
  },
  {
    code: 4374,
    label: 'ß',
  },
  {
    code: 4375,
    label: 'Ŧ',
  },
  {
    code: 4376,
    label: '↓',
  },
  {
    code: 4377,
    label: '“',
  },
  {
    code: 4378,
    label: 'Ł',
  },
  {
    code: 4380,
    label: '←',
  },
  {
    code: 4382,
    label: '¹',
  },
  {
    code: 4383,
    label: '²',
  },
  {
    code: 4384,
    label: '³',
  },
  {
    code: 4385,
    label: '¼',
  },
  {
    code: 4386,
    label: '½',
  },
  {
    code: 4387,
    label: '¾',
  },
  {
    code: 4398,
    label: '¸ (dead)',
  },
  {
    code: 4400,
    label: '~',
  },
  {
    code: 4403,
    label: '´ (dead)',
  },
  {
    code: 4406,
    label: '―',
  },
  {
    code: 4407,
    label: '˙ (dead)',
  },
  {
    code: 4638,
    label: '!',
  },
  {
    code: 4639,
    label: '@',
  },
  {
    code: 4640,
    label: '#',
  },
  {
    code: 4641,
    label: '$',
  },
  {
    code: 4642,
    label: '%',
  },
  {
    code: 4643,
    label: '?',
  },
  {
    code: 4644,
    label: '&',
  },
  {
    code: 4645,
    label: '*',
  },
  {
    code: 4646,
    label: '(',
  },
  {
    code: 4647,
    label: ')',
  },
  {
    code: 4653,
    label: '_',
  },
  {
    code: 4654,
    label: '+',
  },
  {
    code: 4655,
    label: '¨ (dead)',
  },
  {
    code: 4659,
    label: ':',
  },
  {
    code: 4661,
    label: '(backslash)',
  },
  {
    code: 4662,
    label: "'",
  },
  {
    code: 4663,
    label: '"',
  },
  {
    code: 4864,
    label: '®',
  },
  {
    code: 4864,
    label: '®',
  },
  {
    code: 4864,
    label: '¥',
  },
  {
    code: 4864,
    label: '¥',
  },
  {
    code: 4864,
    label: '↑',
  },
  {
    code: 4864,
    label: '↑',
  },
  {
    code: 4864,
    label: 'ı',
  },
  {
    code: 4864,
    label: 'ı',
  },
  {
    code: 4864,
    label: '¯ (dead)',
  },
  {
    code: 4864,
    label: '¯ (dead)',
  },
  {
    code: 4864,
    label: '§',
  },
  {
    code: 4864,
    label: '§',
  },
  {
    code: 4864,
    label: 'ª',
  },
  {
    code: 4864,
    label: 'ª',
  },
  {
    code: 4864,
    label: 'ˇ (dead)',
  },
  {
    code: 4864,
    label: 'ˇ (dead)',
  },
  {
    code: 4864,
    label: '˘ (dead)',
  },
  {
    code: 4864,
    label: '˘ (dead)',
  },
  {
    code: 4864,
    label: '¦',
  },
  {
    code: 4864,
    label: '¦',
  },
  {
    code: 4864,
    label: '©',
  },
  {
    code: 4864,
    label: '©',
  },
  {
    code: 4864,
    label: '‘',
  },
  {
    code: 4864,
    label: '‘',
  },
  {
    code: 4864,
    label: '’',
  },
  {
    code: 4864,
    label: '’',
  },
  {
    code: 4864,
    label: '♪',
  },
  {
    code: 4864,
    label: '♪',
  },
  {
    code: 4864,
    label: 'º',
  },
  {
    code: 4864,
    label: 'º',
  },
  {
    code: 4894,
    label: '¡',
  },
  {
    code: 4894,
    label: '¡',
  },
  {
    code: 4896,
    label: '£',
  },
  {
    code: 4896,
    label: '£',
  },
  {
    code: 4898,
    label: '⅜',
  },
  {
    code: 4898,
    label: '⅜',
  },
  {
    code: 4899,
    label: '⅝',
  },
  {
    code: 4899,
    label: '⅝',
  },
  {
    code: 4900,
    label: '⅞',
  },
  {
    code: 4900,
    label: '⅞',
  },
  {
    code: 4901,
    label: '™',
  },
  {
    code: 4901,
    label: '™',
  },
  {
    code: 4902,
    label: '±',
  },
  {
    code: 4902,
    label: '±',
  },
  {
    code: 4909,
    label: '¿',
  },
  {
    code: 4909,
    label: '¿',
  },
  {
    code: 4910,
    label: '˛ (dead)',
  },
  {
    code: 4910,
    label: '˛ (dead)',
  },
  {
    code: 4911,
    label: '° (dead)',
  },
  {
    code: 4911,
    label: '° (dead)',
  },
  {
    code: 4915,
    label: '˝ (dead)',
  },
  {
    code: 4915,
    label: '˝ (dead)',
  },
  {
    code: 4917,
    label: '(soft hyphen)',
  },
  {
    code: 4917,
    label: '(soft hyphen)',
  },
  {
    code: 4918,
    label: '×',
  },
  {
    code: 4918,
    label: '×',
  },
  {
    code: 4919,
    label: '÷',
  },
  {
    code: 4919,
    label: '÷',
  },
  {
    code: 5128,
    label: '€',
  },
  {
    code: 5147,
    label: '»',
  },
  {
    code: 5149,
    label: '«',
  },
  {
    code: 5153,
    label: '¤',
  },
  {
    code: 5156,
    label: '{',
  },
  {
    code: 5157,
    label: '}',
  },
  {
    code: 5158,
    label: '[',
  },
  {
    code: 5159,
    label: ']',
  },
  {
    code: 5166,
    label: '¬',
  },
  {
    code: 5167,
    label: '` (dead)',
  },
  {
    code: 5168,
    label: '~ (dead)',
  },
  {
    code: 5171,
    label: '°',
  },
  {
    code: 5173,
    label: '|',
  },
  {
    code: 5174,
    label: '<',
  },
  {
    code: 5175,
    label: '>',
  },
];
